// extracted by mini-css-extract-plugin
export default {"chart_container":"CustomPieChart_chart_container__4zjsR","legend_container":"CustomPieChart_legend_container__nRfBp","legend":"CustomPieChart_legend__-2RWo"};